// ====================================================
// 暗号
// ====================================================

export const sha256 = async (text: string) => {
  const uint8 = new TextEncoder().encode(text);
  const digest = await crypto.subtle.digest('SHA-256', uint8);
  return Array.from(new Uint8Array(digest))
    .map(v => v.toString(16).padStart(2, '0'))
    .join('');
};

// ====================================================
// 日付
// ====================================================

/**
 * Dateオブジェクトを指定されたフォーマット形式にして返す
 * YYYY: year, MM: month, DD: date, hh: hour, mm: minute
 * @param targetDate
 * @param format hh:mm, YYYY:MM:DD
 * @returns hh:mm (12:10)
 */
export const convertDateToString = (targetDate: Date, format: string) => {
  if (!targetDate) return format;
  let tmpTargetDate = targetDate;
  if (typeof targetDate === 'string') {
    tmpTargetDate = new Date(targetDate);
  }

  let formatDate = format;
  if (formatDate.includes('YYYY')) {
    const year = String(tmpTargetDate.getFullYear());
    formatDate = formatDate.replace('YYYY', year);
  }
  if (formatDate.includes('MM')) {
    const month = String(tmpTargetDate.getMonth() + 1).padStart(2, '0');
    formatDate = formatDate.replace('MM', month);
  }
  if (formatDate.includes('DD')) {
    const date = String(tmpTargetDate.getDate()).padStart(2, '0');
    formatDate = formatDate.replace('DD', date);
  }
  if (formatDate.includes('hh')) {
    const hour = String(tmpTargetDate.getHours()).padStart(2, '0');
    formatDate = formatDate.replace('hh', hour);
  }
  if (formatDate.includes('mm')) {
    const minute = String(tmpTargetDate.getMinutes()).padStart(2, '0');
    formatDate = formatDate.replace('mm', minute);
  }
  if (formatDate.includes('ss')) {
    const seconds = String(tmpTargetDate.getSeconds()).padStart(2, '0');
    formatDate = formatDate.replace('ss', seconds);
  }
  return formatDate;
};
